module.exports = __webpack_public_path__ + "img/wareflare_h.de60fdb6.svg";